export const getState = (state) => {
	return state.state
}

export const getListItemById = (state) => (args) => {
	return state.list.find(l => l.id == args.id)
}